import React from "react"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import {
  UncontrolledAccordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap"

export const ReusableComponent = ({ customEditField, title, details }) => {
  const navigate = useNavigate()

  const groupedFields = {}
  const ungroupedFields = []

  Object.values(customEditField || {}).forEach(field => {
    const shouldShow =
      field.viewable_by_parents === 1 &&
      !["Mother's Photo", "Father's Photo", "Student's Photo"].includes(
        field.field_title
      ) &&
      field.field_name !== "upload_icon"

    if (shouldShow) {
      const groupTitle = field.accordion_title?.trim()

      if (!groupTitle) {
        ungroupedFields.push(field)
      } else {
        if (!groupedFields[groupTitle]) groupedFields[groupTitle] = []
        groupedFields[groupTitle].push(field)
      }
    }
  })

  return (
    <div className="mb-4">
      <div className="mb-3 d-flex align-items-center">
        <span className="text-primary fs-4 fw-medium">{title}</span>
        {title === "Personal Details" && (
          <i
            onClick={() =>
              navigate("/custom-edit", {
                state: { data: customEditField },
              })
            }
            className="bx bxs-edit ms-auto"
            style={{
              fontSize: "20px",
              borderRadius: "5px",
              color: "#0d6efd",
              cursor: "pointer",
            }}
          ></i>
        )}
      </div>

      {Object.entries(details).map(([key, value]) => (
        <div
          className="d-flex align-items-start justify-content-between mb-2"
          key={key}
        >
          <div className="w-50">
            <span style={{ lineHeight: 2, fontSize: "14px", fontWeight: 600 }}>
              {key}
            </span>
          </div>
          <div className="w-50">
            <span style={{ lineHeight: "2", fontSize: "14px" }}>{value}</span>
          </div>
        </div>
      ))}

      {ungroupedFields.map((field, i) => (
        <div
          className="d-flex align-items-start justify-content-between mb-2"
          key={`ungrouped-${i}`}
        >
          <div className="w-50">
            <span style={{ fontSize: "14px", fontWeight: 600 }}>
              {field.field_title}
            </span>
          </div>
          <div className="w-50">
            {field.field_name === "uploadeddoc" ? (
              Array.isArray(field.value) && field.value.length > 0 ? (
                <button
                  onClick={() =>
                    navigate("/student-doc", {
                      state: {
                        documents: field.value,
                        edit: field.editable_by_parents,
                      },
                    })
                  }
                  className="btn btn-primary btn-sm rounded-pill shadow-sm px-3"
                >
                  View
                </button>
              ) : null
            ) : (
              <span
                style={{
                  //   lineHeight: 2,
                  fontSize: "14px",
                  fontWeight: 400,
                }}
              >
                {[
                  "Birth Date",
                  "mbdate",
                  "admitdate",
                  "bdate",
                  "pdate",
                ].includes(field.field_name) && typeof field.value === "string"
                  ? moment(field.value).format("DD-MM-YYYY")
                  : typeof field.value === "object"
                  ? ""
                  : field.value}
              </span>
            )}
          </div>
        </div>
      ))}

      <UncontrolledAccordion defaultOpen={[Object.keys(groupedFields)[0]]}>
        {Object.entries(groupedFields).map(([groupTitle, fields], index) => (
          <AccordionItem key={index}>
            <AccordionHeader targetId={groupTitle}>
              {groupTitle}
            </AccordionHeader>
            <AccordionBody accordionId={groupTitle}>
              {fields.map((field, i) => (
                <div
                  key={i}
                  className="d-flex align-items-start justify-content-between mb-2"
                >
                  <div className="w-50">
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {field.field_title}
                    </span>
                  </div>
                  <div className="w-50">
                    {field.field_name === "uploadeddoc" ? (
                      Array.isArray(field.value) && field.value.length > 0 ? (
                        <button
                          onClick={() =>
                            navigate("/student-doc", {
                              state: {
                                documents: field.value,
                                edit: field.editable_by_parents,
                              },
                            })
                          }
                          className="btn btn-primary btn-sm rounded-pill shadow-sm px-3"
                        >
                          View
                        </button>
                      ) : null
                    ) : (
                      <span
                        style={{
                          lineHeight: 2,
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        {[
                          "Birth Date",
                          "mbdate",
                          "admitdate",
                          "bdate",
                          "pdate",
                        ].includes(field.field_name) &&
                        typeof field.value === "string"
                          ? moment(field.value).format("DD-MM-YYYY")
                          : typeof field.value === "object"
                          ? ""
                          : field.value}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </AccordionBody>
          </AccordionItem>
        ))}
      </UncontrolledAccordion>
    </div>
  )
}
